import { useState } from "react";

export default ({ initial }) => {
	const [selected, setSelected] = useState(
		initial === 0 ? 0 : initial || null
	);
	const isSelected = selected !== null;
	return { selected, setSelected, isSelected };
};
